import PhotoHeading from '../src/PhotoHeading.tsx';
export default PhotoHeading;
